import { faIcon } from "@utils/faIcon"

import { AccessCheck } from "@particles/index"

import { NavigationSection } from "@molecules/index"

import SideBarItem from "@organisms/SideBar/components/SideBarItem/SideBarItem"

import { CATALOG_ROUTES } from "@routes/catalogs"
import { SETTINGS_ROUTES } from "@routes/settings"

import { PERMISSION_LEVEL } from "@constants/permissionLevel"

function SettingsNavigation() {
    return (
        <>
            <NavigationSection title="My account">
                <SideBarItem
                    label="Profile"
                    icon={faIcon({ name: "circle-user", style: "regular" })}
                    iconActive={faIcon({ name: "circle-user", style: "solid" })}
                    path={SETTINGS_ROUTES.profile}
                    onActive={() => null}
                />
                <SideBarItem
                    label="Preferences"
                    icon={faIcon({ name: "gear", style: "regular" })}
                    iconActive={faIcon({ name: "gear", style: "solid" })}
                    path={SETTINGS_ROUTES.preferences}
                    onActive={() => null}
                />
                <SideBarItem
                    label="Security & access"
                    icon={faIcon({ name: "key", style: "regular" })}
                    iconActive={faIcon({ name: "key", style: "solid" })}
                    path={SETTINGS_ROUTES.securityAndAccess}
                    onActive={() => null}
                />
                <SideBarItem
                    label="Notifications"
                    icon={faIcon({ name: "bell", style: "regular" })}
                    iconActive={faIcon({ name: "bell", style: "solid" })}
                    path={SETTINGS_ROUTES.notifications}
                    onActive={() => null}
                />
            </NavigationSection>
            <AccessCheck
                permissions={{
                    settings_view_permission: PERMISSION_LEVEL.RESTRICTED,
                }}
            >
                <NavigationSection title="Workspace">
                    <AccessCheck
                        entitlements={["entitlement_invoices_enabled", "entitlement_estimates_enabled"]}
                        permissions={{
                            settings_view_permission: PERMISSION_LEVEL.FULL,
                        }}
                    >
                        <AccessCheck
                            permissions={{
                                settings_edit_permission: PERMISSION_LEVEL.FULL,
                            }}
                        >
                            <SideBarItem
                                label="Payments"
                                icon={faIcon({ name: "circle-dollar", style: "regular" })}
                                iconActive={faIcon({ name: "circle-dollar", style: "solid" })}
                                path={SETTINGS_ROUTES.payments}
                                onActive={() => null}
                            />
                        </AccessCheck>
                    </AccessCheck>

                    <AccessCheck
                        permissions={{
                            settings_view_permission: PERMISSION_LEVEL.FULL,
                        }}
                    >
                        <AccessCheck
                            permissions={{
                                settings_edit_permission: PERMISSION_LEVEL.FULL,
                            }}
                        >
                            <SideBarItem
                                label="CompanyCam"
                                icon={faIcon({ name: "camera-retro", style: "regular" })}
                                iconActive={faIcon({ name: "camera-retro", style: "solid" })}
                                path={SETTINGS_ROUTES.companyCam}
                                onActive={() => null}
                            />
                        </AccessCheck>
                    </AccessCheck>
                    <AccessCheck
                        permissions={{
                            settings_view_permission: PERMISSION_LEVEL.FULL,
                        }}
                    >
                        <SideBarItem
                            label="Accounting"
                            icon={faIcon({ name: "receipt", style: "regular" })}
                            iconActive={faIcon({ name: "receipt", style: "solid" })}
                            path={SETTINGS_ROUTES.accounting}
                            onActive={() => null}
                        />
                    </AccessCheck>
                    <AccessCheck
                        permissions={{
                            settings_view_permission: PERMISSION_LEVEL.FULL,
                        }}
                    >
                        <SideBarItem
                            label="E-Commerce"
                            icon={faIcon({ name: "store", style: "regular" })}
                            iconActive={faIcon({ name: "store", style: "solid" })}
                            path={SETTINGS_ROUTES.ecommerce}
                            onActive={() => null}
                        />
                    </AccessCheck>
                    <AccessCheck
                        permissions={{
                            settings_view_permission: PERMISSION_LEVEL.RESTRICTED,
                        }}
                    >
                        <AccessCheck
                            permissions={{
                                pricebook_list_permission: PERMISSION_LEVEL.FULL,
                            }}
                        >
                            <SideBarItem
                                label="Catalogs"
                                icon={faIcon({ name: "shelves", style: "regular" })}
                                iconActive={faIcon({ name: "shelves", style: "solid" })}
                                path={CATALOG_ROUTES.LIST}
                                onActive={() => null}
                            />
                        </AccessCheck>
                    </AccessCheck>
                    <AccessCheck
                        permissions={{
                            settings_view_permission: PERMISSION_LEVEL.RESTRICTED,
                        }}
                    >
                        <AccessCheck
                            entitlements={["entitlement_jobs_enabled"]}
                            permissions={{
                                jobs_list_permission: PERMISSION_LEVEL.FULL,
                            }}
                        >
                            <SideBarItem
                                label="Availability schedules"
                                icon={faIcon({ name: "calendar", style: "regular" })}
                                iconActive={faIcon({ name: "calendar", style: "solid" })}
                                path={SETTINGS_ROUTES.availabilitySchedules}
                                onActive={() => null}
                            />
                        </AccessCheck>
                    </AccessCheck>
                </NavigationSection>
            </AccessCheck>
        </>
    )
}

export default SettingsNavigation
